// Shared copy: navigation bar, footer, language picker.
// Translation of fr/common.js — exactly the same keys.
// The packs.* keys belong in THIS fragment only (tp/tpList read them, falling
// back to the value stored in the database).
export default {
  'nav.home': 'Home',
  'nav.shop': 'Shop',
  'nav.rules': 'Game rules',
  'nav.about': 'About us',
  'nav.contact': 'Contact',
  'nav.cart': 'My basket',
  'nav.admin': 'Administration',
  'nav.adminShort': 'Admin',
  'nav.adminTitle': 'Admin access',
  'nav.order': 'Order now',
  'nav.cartEmpty': 'Your basket is empty',
  'nav.checkout': 'Proceed to checkout',
  'nav.login': 'Log in',
  'nav.loginShort': 'Login',
  'nav.logout': 'Log out',
  'nav.orders': 'Orders',
  'nav.myOrders': 'My orders',
  'nav.profile': 'Profile',
  'nav.myProfile': 'My profile',
  'nav.language': 'Language',

  'footer.tagline':
    'Let’s create magical family moments! Our puzzles turn your baby’s gender reveal into an unforgettable adventure.',
  'footer.badge.interactive': '🎲 Interactive',
  'footer.badge.festive': '🎊 Festive',
  'footer.badge.family': '💝 Family',
  'footer.nav': 'Navigation',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms and conditions',
  'footer.paymentSecurity': 'Payment security',
  'footer.legalNotice': 'Legal notice',
  'footer.connected': 'Stay in touch',
  'footer.newsletter': 'Get the latest news:',
  'footer.newsletterPlaceholder': 'you@email.com',
  'footer.madeWith': 'Made with',
  'footer.madeFor': 'for magical families.',

  // Product copy (normally served from the database, translated here via tp/tpList).
  'packs.flash.name': 'Essential Pack',
  'packs.flash.description': 'The game box on its own — you get the rest ready yourself.',
  'packs.flash.longDescription':
    'You receive the Joyful Reveal box, and nothing else: eleven puzzle pieces to be won question after question, and the twelfth one to scratch — the piece that gives everything away. The rules are summarised on the back of the box and available online too. You write your own questions and sort out something to tell the two teams apart. If you would rather have everything ready to go, take a look at the Premium Pack.',
  'packs.flash.features':
    'The game box and its 12 pieces|11 pieces to win + 1 scratch piece|Rules summarised on the back of the box|Online version of the rules via the QR code',

  'packs.premium.name': 'Premium Pack',
  'packs.premium.description': 'The complete game: everything is ready, all you have to do is receive it.',
  'packs.premium.longDescription':
    'Everything the box contains, plus the three extras that make the evening: two cotton pouches to tell the teams apart, the questionnaire printed on 400 g card with the eleven questions already written and a blank template for inventing your own, and a keepsake envelope to slip behind a picture frame once the party is over.',
  'packs.premium.features':
    'The game box and its 12 pieces|2 cotton pouches for the two teams|The questionnaire printed on 400 g card|A blank template for your own questions|The keepsake envelope to hold on to after the party',
  "footer.maFacture": "Find my invoice",
};
